import { render, staticRenderFns } from "./OsAguardandoLiberacao.vue?vue&type=template&id=4580f324&"
import script from "./OsAguardandoLiberacao.vue?vue&type=script&lang=js&"
export * from "./OsAguardandoLiberacao.vue?vue&type=script&lang=js&"
import style0 from "./OsAguardandoLiberacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports